<template>
  <div>
          <!-- <pre>{{courseContent}}</pre>  -->
    <div>
      <h3 class="course-heading">{{ courseContent.name }}</h3>
      <div class="cstm-breadcrumb">
        <p class="bread-menus">Course Content</p>
      </div>
      <h4 class="mb-4">{{ courseContent.description }}</h4>
      <!-- <p class="mb-3">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p> -->
      <!-- {{courseContent.courseContent}} -->
        <vs-tabs class="cstm-card">
      <vs-tab label="Content" icon-pack="feather" icon="icon-align-justify">
        <div>
          <vs-card>
              <p class="mb-3" v-html="courseContent.courseContent.content"
      v-if="courseContent.courseContent && courseContent.courseContent.content != null"
      ></p>
          </vs-card>
        </div>
      </vs-tab>
      <!-- <vs-tab label="Q&A" icon-pack="feather" icon="icon-help-circle">
        <vs-card>
      <question-modal
      v-if="courseContent.courseQuestions && courseContent.courseQuestions.length"
      :QuestionModal="courseContent.courseQuestions"
      :course_id="courseContent.id"
      :sectionType="1"
      Modaltype="Question"

      ></question-modal>
        </vs-card>
      </vs-tab> -->
      <!-- <vs-tab label="Assignments" icon-pack="feather" icon="icon-file-text">
        <assignment-modal
        :lessonAssignment ="courseContent.courseAssignments"
        :sectionType="1"

        ></assignment-modal>
      </vs-tab> -->
      
        <vs-tab
          label="Exams"
          icon-pack="feather"
          icon="icon-file-text"
        >

          <!-- <pre>{{courseContent.courseAssignments}}</pre> -->
        
          <assignment-modal
            :lessonAssignment="examData"
          :sectionType="1"
          ></assignment-modal>
        </vs-tab>
          <vs-tab
          label="HomeWork"
          icon-pack="feather"
          icon="icon-file-text"
        >
          <assignment-modal
            :lessonAssignment="homeworkData"
          :sectionType="1"
          ></assignment-modal>
        </vs-tab>

           <vs-tab
          label="Reports"
          icon-pack="feather"
          icon="icon-file-text"
        >
          <assignment-modal
            :lessonAssignment="reportData"
          :sectionType="1"
          ></assignment-modal>
        </vs-tab>
      
      <vs-tab label="Files" icon-pack="feather" icon="icon-file">
        <div>
          <div class="flex flex-wrap -mx-2">
            <div
              v-for="(eachFiles, index) in courseContent.courseFiles"
              :key="index"
              class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
            >
              <vs-card class="file-card">
                <div slot="header">
                  <img
                    class="w-full file-image"
                    :src="eachFiles.file.file_path"
                    alt=""
                  />
                </div>
                <h5 class="file-name">{{ eachFiles.file.file_name }}</h5>
                <p>{{ eachFiles.file.size }}</p>
                <vs-button color="success" 
                                      class="float-right"
                                      type="flat" @click="downloadImage(eachFiles.file)" icon-pack="feather" icon="icon-download"></vs-button>
                <!-- <a class="float-right" href="#"
                  ><feather-icon icon="DownloadIcon"
                /></a> -->
              </vs-card>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
      <!-- <p class="mb-3" v-html="courseContent.courseContent.content"
      v-if="courseContent.courseContent && courseContent.courseContent.content != null"
      ></p> -->
    </div>

    <!-- <vs-row vs-w="12">
      <vs-col type="flex" vs-w="4">
        <vs-button
          icon-pack="feather"
          icon="icon-chevron-left"
          :to="{
            name: 'CourseDetails1',
            params: { courseId: courseContent.slug },
          }"
          >Back To Course</vs-button
        >
      </vs-col>
      <vs-col type="flex" vs-w="4"
     v-if="!courseContent.courseComplete"
      >
        <vs-button
          color="success"
          type="border"
          @click="saveComplete(courseContent.id)"

          >Mark As Complete</vs-button
        >
      </vs-col>

      <vs-col type="flex" vs-w="4" v-else>
        
        <vs-button color="success" icon-pack="feather" icon="icon-check"
          >Completed</vs-button
        >
      </vs-col>
      <vs-col type="flex" vs-w="4">
        <vs-button
          v-if="courseContent.courseLessons && courseContent.courseLessons.length"
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextLesson()"
          >{{ courseContent.courseLessons[0].lesson.name }}
        </vs-button>
      </vs-col>
    </vs-row> -->
  </div>
</template>

<script>
// import { MarkCompleteMixin } from '../mixins/MarkCompleteMixin'
import QuestionModal from './QuestionModal.vue'
import AssignmentModal from './AssignmentModal.vue'
import axios from 'axios'


export default {
  props: {
    courseContent: {
      required: true,
      default: () => {}
    }
  },
  components:{
    QuestionModal,
    AssignmentModal
  },
  data () {
    return {
      homeworkData:[],
      examData:[],
      reportData:[]

    }
  },
  mounted () {
  },
  watch:{
    courseContent (newVal, oldVal) {
      if (newVal) {
        this.setRequiredData()
      }
    }
  },
  // mixins: [MarkCompleteMixin],
  methods: {
    setRequiredData () {
      this.homeworkData = this.courseContent.courseAssignments.filter(ele => {
        console.log(ele)
        if (ele.assignment) {
          return ele.assignment.assignment_type_id === 2
        }
      })

      this.examData = this.courseContent.courseAssignments.filter(ele => {
        if (ele.assignment) {

          return ele.assignment.assignment_type_id === 4
        }
      })

      this.reportData = this.courseContent.courseAssignments.filter(ele => {
        if (ele.assignment) {

          return ele.assignment.assignment_type_id === 3
        }
      })
    },
    redirectNextLesson () {
      
      this.$emit('backToLesson', 0)
    },
    saveComplete (courseId) {
      
      const payload = {
        course_id: courseId,
        type: 1
      }

      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        
        this.courseContent.courseComplete = 1
      }
    },
    downloadImage (item) {
      
      axios({
        url: `https://cors-anywhere.herokuapp.com/${  item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      }).catch(error => {
        
      }).finally(() => {
        

      })

    }
  }
}
</script>